(() => {
  const topBanner = document.querySelector('.top-banner');
  const topBannerCloseEl = document.querySelector('.top-banner__close');
  const storeKey = 'isTopBannerDismissed';
  const isDismissed = window.sessionStorage && window.sessionStorage.getItem(storeKey) === 'yes';
  if (!topBanner || !topBannerCloseEl || isDismissed) {
    return;
  }
  topBanner.classList.add('is-show');
  topBannerCloseEl.addEventListener('click', e => {
    e.preventDefault();
    e.stopImmediatePropagation();
    topBanner.classList.remove('is-show');
    window.sessionStorage.setItem(storeKey, 'yes');
  });
  topBanner.addEventListener('click', e => {
    e.preventDefault();
    window.location.href = process.env.APP_BASE_URL;
  });
})();
